import type { StateCreator } from 'zustand';

export interface GlobalFilterSliceState {
  vehicleGroupIds: string[];
  setVehicleGroupIds: (vehicleGroupIds: string[]) => void;
}

type StateCreatorGlobalFilter = StateCreator<GlobalFilterSliceState>;

const initialStates = {
  vehicleGroupIds: [],
};

const createGlobalFilterSlice: StateCreatorGlobalFilter = (set) => ({
  ...initialStates,
  setVehicleGroupIds: (vehicleGroupIds: string[]) => set({ vehicleGroupIds }),
});

export default createGlobalFilterSlice;
